import React from 'react';
import styles from './CertificateGenerate.module.scss';
import strings from '../../lang/lang';

const CertificateGenerate = () => {
  return (
    <div className={styles.generate_certificate}>
      <div className={styles.generate_certificate__title}>{strings.certificateGenerate.text.title}</div>
        <p className={styles.generate_certificate__desc}>
          {strings.certificateGenerate.text.description}
        </p>
        <ol className={styles.generate_certificate__list_keys}>
          <li className={styles.generate_certificate__list_item}>
            <p className={styles.generate_certificate__list_label}>{strings.certificateGenerate.text.command1Text}</p>
            <p className={styles.generate_certificate__list_key}>$ openssl genrsa -out server.key 2048</p>
          </li>
          <li className={styles.generate_certificate__list_item}>
            <p className={styles.generate_certificate__list_label}>{strings.certificateGenerate.text.command2Text}</p>
            <p className={styles.generate_certificate__list_key}>$ openssl req -sha256 -new -key server.key -out server.csr</p>
          </li>
        </ol>
        <div className={styles.generate_certificate__requirements}>
            <div className={styles.generate_certificate__requirements_label}>{strings.certificateGenerate.text.requirements}</div>
            <ul className={styles.generate_certificate__requirements_list}>
              <li className={styles.generate_certificate__requirements_item}>{strings.certificateGenerate.text.requirement1}</li>
              <li className={styles.generate_certificate__requirements_item}>{strings.certificateGenerate.text.requirement2}</li>
              <li className={styles.generate_certificate__requirements_item}>{strings.certificateGenerate.text.requirement3}</li>
              <li className={styles.generate_certificate__requirements_item}>
                {strings.formatString(strings.certificateGenerate.text.requirement4,
                  <a
                    href="/docs/guides/sandbox/certificates-management"
                    target="_blank"
                    style={{color: 'gray', textDecoration: 'none'}}
                  >
                    the Certificate Issuing Guide
                  </a>
                )}
              </li>
            </ul>
        </div>
    </div>
  )
};

export default CertificateGenerate;
